import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { MachineOverviewItem, UserOverviewItem } from "./models";

export const overviewApi = createApi({
  baseQuery,
  reducerPath: "overviewApi",
  tagTypes: ["Overview"],
  endpoints: (builder) => ({
    getMachineOverview: builder.query<MachineOverviewItem[], void>({
      query: () => ({
        url: "/api/v1/tasks/machine_overview/",
        method: "GET",
      }),
      providesTags: ["Overview"],
    }),
    getUserOverview: builder.query<UserOverviewItem[], void>({
      query: () => ({
        url: "/api/v1/tasks/user_overview/",
        method: "GET",
      }),
      providesTags: ["Overview"],
    }),
  }),
});

export const { useGetMachineOverviewQuery, useGetUserOverviewQuery } =
  overviewApi;
